import { FunctionComponent } from 'react';
import ReactPaginate from 'react-paginate';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutPagination: FunctionComponent<Props> = ({ currentPage, lastPage, onPageChange, hrefBuilder }) => {
    return (
        <StyledComponent className="layout-pagination">
            <ReactPaginate
                pageCount={lastPage}
                forcePage={currentPage - 1}
                pageRangeDisplayed={4}
                marginPagesDisplayed={1}
                breakLabel='...'
                onPageChange={({ selected }: { selected: number }) => {
                    if (selected + 1 === currentPage) {
                        return;
                    }

                    onPageChange(selected + 1);
                }}
                hrefBuilder={(page: number) => hrefBuilder(page)}
            />
        </StyledComponent>
    );
};

export default LayoutPagination;